/* eslint-disable no-unused-vars */
import { isIdFromObject } from '../../util/validationHelpers';
import _cloneDeep from 'lodash/cloneDeep';
export const concatenateDOBFields = (day, month, year) => `${year}-${month}-${day}`;
export const isValidDateFormat = dateString => /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$/.test(dateString);
/**
 * Extracts either the day, month and year from the pasted text (if an entire date) is pasted or extracts the specific date component pasted (e.g. day, month or year)
 *
 * @important
 * The following entire date formats are currently supported for pasting:
 * - dd/mm/yyyy
 * - dd-mm-yyyy
 *
 */
export const extractDateDetails = (pastedText, fieldType) => {
  const result = pastedText.match(/(?<day>^\d{2})[-/](?<month>\d{2})[-/](?<year>\d{4})$|(?<dateComponent>^\d{2}$|^\d{4}$)/);
  let newDateValues = null;
  if (result && result.groups) {
    const {
      day,
      month,
      year,
      dateComponent
    } = result.groups;
    if (dateComponent) {
      if (fieldType === 'year' && dateComponent.length === 4 || ['day', 'month'].includes(fieldType) && dateComponent.length === 2) {
        newDateValues = {
          [fieldType]: dateComponent
        };
      }
    } else {
      newDateValues = {
        day,
        month,
        year
      };
    }
  }
  return newDateValues;
};
export const createDateFieldString = (isFieldArray, formikValues, dateFieldNames) => {
  let day;
  let month;
  let year;
  if (isFieldArray) {
    const [dayID, dayIndex, dayField] = dateFieldNames.day.split('.');
    const [monthID, monthIndex, monthField] = dateFieldNames.month.split('.');
    const [yearID, yearIndex, yearField] = dateFieldNames.year.split('.');
    day = formikValues[dayID][dayIndex][dayField];
    month = formikValues[monthID][monthIndex][monthField];
    year = formikValues[yearID][yearIndex][yearField];
  } else {
    day = formikValues[dateFieldNames.day];
    month = formikValues[dateFieldNames.month];
    year = formikValues[dateFieldNames.year];
  }
  return concatenateDOBFields(day, month, year);
};
const getDayFieldString = (isFieldArray, formikValues, dateFieldNames) => {
  try {
    if (isFieldArray) {
      const [dayID, dayIndex, dayField] = dateFieldNames.day.split('.');
      return formikValues[dayID][dayIndex][dayField];
    } else {
      return formikValues[dateFieldNames.day];
    }
  } catch (err) {
    console.log('$$$-getDayFieldString-error', err); //eslint-disable-line
    return '';
  }
};
const getMonthFieldString = (isFieldArray, formikValues, dateFieldNames) => {
  try {
    if (isFieldArray) {
      const [monthID, monthIndex, monthField] = dateFieldNames.month.split('.');
      return formikValues[monthID][monthIndex][monthField];
    } else {
      return formikValues[dateFieldNames.month];
    }
  } catch (err) {
    console.log('$$$-getMonthFieldString-error', err); //eslint-disable-line
    return '';
  }
};
const getYearFieldString = (isFieldArray, formikValues, dateFieldNames) => {
  try {
    if (isFieldArray) {
      const [yearID, yearIndex, yearField] = dateFieldNames.year.split('.');
      return formikValues[yearID][yearIndex][yearField];
    } else {
      return formikValues[dateFieldNames.year];
    }
  } catch (err) {
    console.log('$$$-getYearFieldString-error', err); //eslint-disable-line
    return '';
  }
};
const getHiddenDOBFieldString = (isFieldArray, formikValues, fieldName) => {
  try {
    if (isFieldArray) {
      const [membersArray, Index, dateFieldName] = fieldName.split('.');
      return formikValues[membersArray][Index][dateFieldName];
    } else {
      return formikValues[fieldName];
    }
  } catch (err) {
    console.log('$$$-getHiddenDOBFieldString-error', err); //eslint-disable-line
    return '';
  }
};
export const addCurrentTargetValueToFormik = (isFieldArray, formikValues, e) => {
  if (isFieldArray) {
    const [arrayName, fieldIndex, fieldValue] = e.target.id.split('.');
    formikValues[arrayName][fieldIndex][fieldValue] = e.target.value;
  } else {
    formikValues[e.target.id] = e.target.value;
  }
  return formikValues;
};
export const addValidatedDOBFieldToFormik = (isFieldArray, formikValues, fieldName, dateFieldValue) => {
  if (isFieldArray) {
    const [membersArray, Index, dateFieldName] = fieldName.split('.');
    formikValues[membersArray][Index][dateFieldName] = dateFieldValue;
  } else {
    formikValues[fieldName] = dateFieldValue;
  }
  return formikValues;
};
/**
 * Gets the suffix of a date field name
 *
 */
export const getFieldNameSuffix = fieldName => (fieldName === null || fieldName === void 0 ? void 0 : fieldName.split('.').pop()) || '';
/**
 * Get the value of the touched state of the hidden field
 *
 */
export const getHiddenFieldTouched = (newFormTouchedState, dateFieldNames) => Object.values(dateFieldNames).every(fieldName => newFormTouchedState[getFieldNameSuffix(fieldName)]);
/**
 * Gets the value of hidden field
 *
 */
export const getHiddenFieldValue = (newFormValues, dateFieldNames) => {
  const isDayMonthYearAllFilled = Object.values(dateFieldNames).every(fieldName => newFormValues[getFieldNameSuffix(fieldName)]);
  const hiddenFieldValue = '';
  if (isDayMonthYearAllFilled) {
    const {
      [getFieldNameSuffix(dateFieldNames.day)]: day,
      [getFieldNameSuffix(dateFieldNames.month)]: month,
      [getFieldNameSuffix(dateFieldNames.year)]: year
    } = newFormValues;
    return concatenateDOBFields(day, month, year);
  }
  return hiddenFieldValue;
};
/**
 * Generates the new form values state
 */
export const generateNewValuesState = (fieldName, dateFieldNames, previousFormikValues, newDateValues) => {
  const isFieldArray = fieldName.includes('.');
  let newFormikValues = isFieldArray ? _cloneDeep(previousFormikValues) : {
    ...previousFormikValues
  };
  const defaultedDateFieldNames = {
    ...dateFieldNames,
    hiddenField: dateFieldNames.hiddenField || ''
  };
  // Formats the field names of the new date values object to match the names in the dateFieldNames object
  const formattedNewDateValues = Object.keys(newDateValues).reduce((acc, key) => ({
    ...acc,
    [getFieldNameSuffix(defaultedDateFieldNames[key])]: newDateValues[key]
  }), {});
  if (isFieldArray) {
    const [arrayName, arrayIndex, hiddenField] = fieldName.split('.');
    newFormikValues[arrayName][arrayIndex] = Object.assign(newFormikValues[arrayName][arrayIndex], formattedNewDateValues);
    newFormikValues[arrayName][arrayIndex][hiddenField] = getHiddenFieldValue(newFormikValues[arrayName][arrayIndex], dateFieldNames);
  } else {
    newFormikValues = Object.assign(newFormikValues, formattedNewDateValues);
    newFormikValues[fieldName] = getHiddenFieldValue(newFormikValues, dateFieldNames);
  }
  return newFormikValues;
};
export const isFormikFieldValid = (form, formFieldName) => {
  if (formFieldName && isIdFromObject(formFieldName)) {
    const [arrayID, arrayIndex, dateFieldName] = formFieldName.split('.');
    if (form && form.errors && form.errors[arrayID] && form.errors[arrayID][arrayIndex]) {
      return !form.errors[arrayID][arrayIndex][dateFieldName];
    }
    return true;
  }
  return formFieldName && (form === null || form === void 0 ? void 0 : form.errors) ? !(form === null || form === void 0 ? void 0 : form.errors[formFieldName]) : true;
};
export const isFormikFieldTouched = (form, formFieldName) => {
  if (formFieldName && isIdFromObject(formFieldName)) {
    const [arrayID, arrayIndex, dateFieldName] = formFieldName.split('.');
    if (form && form.touched[arrayID] && form.touched[arrayID][arrayIndex]) {
      return Boolean(form.touched[arrayID][arrayIndex][dateFieldName]);
    }
    return false;
  }
  return formFieldName ? Boolean(form === null || form === void 0 ? void 0 : form.touched[formFieldName]) : false;
};
export const getFormikDateFieldValue = (form, formFieldName) => {
  let fieldValue = '';
  if (formFieldName && isIdFromObject(formFieldName)) {
    const [arrayID, arrayIndex, dateFieldName] = formFieldName.split('.');
    if (form && form.values[arrayID] && form.values[arrayID][arrayIndex] && form.values[arrayID][arrayIndex][dateFieldName]) {
      fieldValue = form.values[arrayID][arrayIndex][dateFieldName];
    }
  }
  if (form && formFieldName && form.values[formFieldName]) {
    fieldValue = form.values[formFieldName];
  }
  return fieldValue;
};
// eg 01, 12, 30 etc, but no 40
const dayDoubleFigureFirstDigits = ['0', '1', '2', '3'];
// eg 01 12, but no 20
const monthDoubleFigureFirstDigits = ['0', '1'];
export const setFocusToNextField = (e, dateFieldNames) => {
  try {
    const currentFieldId = e.target.id;
    // only go next on numbers pressed, no slashes, letters etc.
    if (/^\d{1,10}$/.test(e.target.value)) {
      let currentField = undefined;
      if (currentFieldId === dateFieldNames.day) {
        currentField = document.getElementById(dateFieldNames.month);
      }
      if (currentFieldId === dateFieldNames.month) {
        currentField = document.getElementById(dateFieldNames.year);
      }
      if (currentField && currentField.focus) {
        currentField.focus();
      }
      // https://stackoverflow.com/questions/511088/use-javascript-to-place-cursor-at-end-of-text-in-text-input-element
      // Typescript error: Property 'selectionStart' does not exist on type 'HTMLElement'. Did you mean 'onselectstart'?ts(2551) todo: find out if this code works code actually work??
      setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (currentField) currentField.selectionStart = currentField.value.length;
      }, 0);
    }
  } catch (err) {
    console.log('$$$-setFocusToNextField-error', err); //eslint-disable-line
  }
};
export const setFocusToPreviousField = (e, dateFieldNames) => {
  try {
    const currentFieldId = e.target.id;
    if (currentFieldId !== dateFieldNames.day) {
      let currentField = undefined;
      if (currentFieldId === dateFieldNames.year) {
        currentField = document.getElementById(dateFieldNames.month);
      }
      if (currentFieldId === dateFieldNames.month) {
        currentField = document.getElementById(dateFieldNames.day);
      }
      if (currentField && currentField.focus) {
        currentField.focus();
      }
      // https://stackoverflow.com/questions/511088/use-javascript-to-place-cursor-at-end-of-text-in-text-input-element
      // Typescript error: Property 'selectionStart' does not exist on type 'HTMLElement'. Did you mean 'onselectstart'?ts(2551) does this code actually work??
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setTimeout(() => currentField.selectionStart = currentField.value.length, 0);
    }
  } catch (err) {
    console.log('$$$-setFocusToPreviousField-error', err); //eslint-disable-line
  }
};
/**
 * Generates the new touched form state for the date of birth component
 */
export const generateNewTouchedState = (fieldName, dateFieldNames, touched, touchedFields) => {
  const isFieldArray = fieldName.includes('.');
  let newFormikTouchedState = isFieldArray ? _cloneDeep(touched) : {
    ...touched
  };
  const defaultedDateFieldNames = {
    ...dateFieldNames,
    hiddenField: dateFieldNames.hiddenField || ''
  };
  const formattedNewTouchedState = touchedFields.reduce((newTouchedState, key) => ({
    ...newTouchedState,
    [getFieldNameSuffix(defaultedDateFieldNames[key])]: true
  }), {});
  if (isFieldArray) {
    const [arrayName, arrayIndex, hiddenField] = fieldName.split('.');
    newFormikTouchedState[arrayName][arrayIndex] = Object.assign(newFormikTouchedState[arrayName][arrayIndex], formattedNewTouchedState);
    newFormikTouchedState[arrayName][arrayIndex][hiddenField] = getHiddenFieldTouched(newFormikTouchedState[arrayName][arrayIndex], dateFieldNames);
  } else {
    newFormikTouchedState = Object.assign(newFormikTouchedState, formattedNewTouchedState);
    newFormikTouchedState[fieldName] = getHiddenFieldTouched(newFormikTouchedState, dateFieldNames);
  }
  return newFormikTouchedState;
};
/*
  Only sets it to touched if certain conditions met.
  Eg, date fields are empty but form has had a submission attempt which sets them all to touched.
  In this instance we want the 3 fields to stay touched but also the hidden field, so the message always shows for realtime validation
*/
export const setHiddenFieldTouched = (touched, submitCount, setFieldTouched, fieldName) => {
  const allDateFieldsTouched = touched[`${fieldName}Day`] && touched[`${fieldName}Month`] && touched[`${fieldName}Year`];
  if ((allDateFieldsTouched || submitCount) && setFieldTouched) {
    setFieldTouched(fieldName, true);
  }
};
// adds value to next field if currently field is full and a day or month (years have no next field).
export const handleFieldAlreadyFilled = (setFieldValue, event, dateFieldNames, maxLength, fieldType) => {
  try {
    setFocusToNextField(event, dateFieldNames);
    let nextFieldsEntry = event.target.value.substring(maxLength, maxLength + 1);
    if (fieldType === 'day') {
      // if single digit for month above 1, eg 2 then set field to 02.
      if (nextFieldsEntry.length === 1 && !monthDoubleFigureFirstDigits.includes(nextFieldsEntry)) {
        nextFieldsEntry = String(nextFieldsEntry).padStart(2, '0');
      }
      if (setFieldValue) setFieldValue(dateFieldNames.month, nextFieldsEntry);
    }
    if (fieldType === 'month' && setFieldValue) {
      setFieldValue(dateFieldNames.year, nextFieldsEntry);
    }
  } catch (err) {
    console.log('$$$-handleFieldAlreadyFilled-error', err); //eslint-disable-line
  }
};
// eg for month of 9 entered, add a zero, but not for 1 as it could be the user wants 01,10,11,12 etc
export const addPrecedingZeroIfSubTenValue = (e, handleChange, fieldType, isFieldArray, formikValues, dateFieldNames) => {
  try {
    if (fieldType === 'day') {
      const dayNewValue = getDayFieldString(isFieldArray, formikValues, dateFieldNames);
      // if first character above 3 eg 4 then prepend a zero, 04
      if (dayNewValue.length === 1 && !dayDoubleFigureFirstDigits.includes(dayNewValue)) {
        e.target.value = String(dayNewValue).padStart(2, '0');
        handleChange(e);
      }
    }
    if (fieldType === 'month') {
      const monthNewValue = getMonthFieldString(isFieldArray, formikValues, dateFieldNames);
      // if single digit for month above 1, eg 2 then set field to 02.
      if (monthNewValue.length === 1 && !monthDoubleFigureFirstDigits.includes(monthNewValue)) {
        e.target.value = String(monthNewValue).padStart(2, '0');
        handleChange(e);
      }
    }
  } catch (err) {
    console.log('$$$-addPrecedingZeroIfSubTenValue-error', err); //eslint-disable-line
  }
};
export const getPreviousDateFieldValues = (isFieldArray, formikValues, dateFieldNames, fieldName) => {
  const day = getDayFieldString(isFieldArray, formikValues, dateFieldNames);
  const month = getMonthFieldString(isFieldArray, formikValues, dateFieldNames);
  const year = getYearFieldString(isFieldArray, formikValues, dateFieldNames);
  const hiddenField = getHiddenDOBFieldString(isFieldArray, formikValues, fieldName);
  return {
    day,
    month,
    year,
    hiddenField
  };
};
export const isAllDateFieldsEmpty = (fieldType, currentTargetValue, dateFields) => {
  var _a, _b;
  try {
    /*
      Use the currentTargetValue as the latest changes haven't been added to formik yet.
      Eg, If a month is being updated, delete the old one from the dateFields Array and go with currentTargetValue
    */
    delete dateFields[fieldType];
    const totalDigitsAcrossAllDOBFields = (_b = (_a = Object.values(dateFields)) === null || _a === void 0 ? void 0 : _a.concat(currentTargetValue)) === null || _b === void 0 ? void 0 : _b.reduce((total, fieldValue) => {
      return Number(total) + Number(fieldValue.length);
    }, 0);
    return Boolean(totalDigitsAcrossAllDOBFields < 1);
  } catch (err) {
    console.log('$$$-isAllDateFieldsEmpty-error', err); //eslint-disable-line
    return false;
  }
};